module.exports = __webpack_public_path__ + "img/violet_057.5ac02520.png";